/* eslint-disable react/prop-types */
import {
  Box, Typography, InputBase, Icon,
} from '@material-ui/core';
import React, { useState, useEffect, useRef } from 'react';
import { paginationStyles } from '../tableStyles';
import RightArrow from '../../../Assets/Svg/rightArrow.svg';
import LeftArrow from '../../../Assets/Svg/leftArrow.svg';

function Pagination({
  currentPage,
  handlePrevPage,
  handleNextPage,
  pageInfo,
  onJumpToPage // Optional: enables jump feature when provided
}) {
  const classes = paginationStyles();

  // Jump feature state (only used when onJumpToPage is provided)
  const [inputValue, setInputValue] = useState(currentPage + 1);
  const [errorMessage, setErrorMessage] = useState('');
  const debounceTimerRef = useRef(null);

  const isJumpEnabled = !!onJumpToPage;
  const totalPages = pageInfo?.totalPages;
  const showTotalPages = isJumpEnabled && totalPages;

  // Update input value when currentPage changes externally
  useEffect(() => {
    if (isJumpEnabled) {
      setInputValue(currentPage + 1);
      setErrorMessage('');
    }
  }, [currentPage, isJumpEnabled]);

  const validateAndJump = (pageNumber) => {
    const page = parseInt(pageNumber, 10);

    if (isNaN(page) || pageNumber === '') {
      setErrorMessage('Enter a valid page number');
      return false;
    }

    if (page < 1) {
      setErrorMessage('Must be at least 1');
      return false;
    }

    if (totalPages && page > totalPages) {
      setErrorMessage(`Max page is ${totalPages}`);
      return false;
    }

    if (page === currentPage + 1) {
      setErrorMessage('');
      return false;
    }

    setErrorMessage('');
    onJumpToPage(page - 1); // Convert to 0-indexed
    return true;
  };

  const handleInputChange = (e) => {
    const value = e.target.value;

    if (value === '' || /^\d+$/.test(value)) {
      setInputValue(value);

      if (errorMessage) {
        setErrorMessage('');
      }

      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }

      if (value !== '') {
        debounceTimerRef.current = setTimeout(() => {
          validateAndJump(value);
        }, 800);
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
      const success = validateAndJump(inputValue);
      if (!success && inputValue !== '') {
        setInputValue(currentPage + 1);
      }
    }
  };

  const handleBlur = () => {
    if (inputValue === '' || errorMessage) {
      setInputValue(currentPage + 1);
      setErrorMessage('');
    }
  };

  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  return (
    <Box className={classes.box}>
      <Typography className={classes.title}>Page</Typography>
      <InputBase
        readOnly={!isJumpEnabled}
        placeholder="1"
        value={isJumpEnabled ? inputValue : currentPage + 1}
        onChange={isJumpEnabled ? handleInputChange : undefined}
        onKeyDown={isJumpEnabled ? handleKeyPress : undefined}
        onBlur={isJumpEnabled ? handleBlur : undefined}
        className={classes.input}
        inputProps={{
          "aria-label": "search",
          style: isJumpEnabled ? { textAlign: 'center' } : {}
        }}
      />
      {showTotalPages && (
        <Typography className={classes.title} style={{ marginLeft: '4px', marginRight: '8px' }}>
          / {totalPages}
        </Typography>
      )}
      {errorMessage && (
        <Typography
          variant="caption"
          style={{
            color: '#f44336',
            fontSize: '0.7rem',
            marginRight: '8px',
            whiteSpace: 'nowrap'
          }}
        >
          {errorMessage}
        </Typography>
      )}
      <Icon
        className={`${classes.arrowBox} ${pageInfo.hasPreviousPage ? classes.arrowBox : classes.disabledArrowBox
          }`}
        onClick={handlePrevPage}
      >
        <img alt="imageAlt" className={classes.icon} src={LeftArrow} />
      </Icon>
      <Icon
        className={`${pageInfo.hasNextPage ? classes.arrowBox : classes.disabledArrowBox
          }`}
        onClick={handleNextPage}
      >
        <img alt="imageAlt" className={classes.icon} src={RightArrow} />
      </Icon>
    </Box>
  );
}

export default Pagination;
